<h2 mat-dialog-title>{{point_id? 'Update Scanning Point' : 'Add Scanning Point'}}</h2>
<form [formGroup]="ScanningForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">
        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Scanning Point</mat-label>
                <input [ngModel]="point" formControlName="point" matInput placeholder="Ex.Entry Gate">

            </mat-form-field>
        </div>

        <div class="column">
            <mat-label>Send Whatsapp On Checkin :</mat-label>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="whatsapp_checkin"
                formControlName="whatsapp_checkin">
                <mat-radio-button value="yes">Yes</mat-radio-button>
                <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
        </div>

        <mat-form-field *ngIf="whatsapp_checkin == 'yes'" appearance="outline">
            <mat-label>Message On Check In</mat-label>
            <textarea matInput [ngModel]="whatsapp_checkin_msg" formControlName="whatsapp_checkin_msg"></textarea>
        </mat-form-field>

        <!-- <hr> -->
        <div class="column">
            <mat-label>Send Whatsapp On Checkout :</mat-label>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="whatsapp_checkout"
                formControlName="whatsapp_checkout">
                <mat-radio-button value="yes">Yes</mat-radio-button>
                <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-form-field *ngIf="whatsapp_checkout == 'yes'" appearance="outline">
            <mat-label>Message On Check Out</mat-label>
            <textarea matInput [ngModel]="whatsapp_checkout_msg" formControlName="whatsapp_checkout_msg"></textarea>
        </mat-form-field>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Scan Method :</mat-label>
                <mat-select aria-label="Select an option" [ngModel]="scan_method" formControlName="scan_method">
                    <mat-option value="1">Check-In</mat-option>
                    <mat-option value="2">Check-In & Check-Out</mat-option>
                    <mat-option value="0">Multiple Check-In</mat-option>
                    <mat-option value="3">Multiple Check-In & Check-Out</mat-option>
                    <mat-option value="4">Check-In Only Once</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{point_id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>